import * as React from "react";
import { Button, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { ReactComponent as DeleteIcon } from "assets/images/icons/DeleteWarningIcon.svg";

// import { ReactComponent as EditIcon } from "assets/images/icons/EditIcon.svg";

import { DialogTitle, Grid, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";
import CommonButton from "./Button";

// import EditNoteIcon from '@mui/icons-material/EditNote';
import { ReactComponent as EditConfirmIcon } from "assets/images/icons/EditConfirmDailog.svg";

const useStyle = makeStyles((theme) => ({
  dialog: {
    position: "absolute",
    top: 200,
    width: 500,
    [theme.breakpoints.between("xs", "sm")]: {
      width: "80%",
    },
  },
  hrClose: {
    position: "absolute",
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
  hrText: {
    color: "#000",
    marginTop: 25,
    textAlign: "center",
  },
  hrMargin: {
    marginBottom: 20,
  },
  hrButton: {
    marginBottom: "15px",
    justifyContent: "center",
  },
  hrMainText: {
    display: "content",
    gap: "10px",
    textAlign: "center",
  },
  hrIcon: {
    display: "flex",
    justifyContent: "center", // Center the content horizontally
    alignItems: "center",
    textAlign: "center",
    color: "#e27534",
    "& svg": {
      fontSize: "8rem",
      height: "6.5rem",
      // textAlign: "center",
    },
    "& path": {
      // fill:" #e27534"
    },
  },
}));
/** common edit dialog component */
export default function ConfirmEditDialog(props) {
  const {
    openStatus,
    confirmAction,
    confirmText = "Are you sure you want to Update?",
    btnLable = "Update",
    icon = <EditConfirmIcon />,
    loading = false,
    contentJSX,
    iconColor,
  } = props;
  const classes = useStyle();
  return (
    <Dialog
      open={openStatus}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{ paper: classes.dialog }}
    >
      <DialogTitle className={classes.hrMargin}>
        <IconButton
          aria-label="close"
          onClick={() => confirmAction(false)}
          className={classes.hrClose}
          color="error"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid 
        className={classes.hrIcon} 
        style={{ 
          color: iconColor ? iconColor : "#e27534"
        }}
        >
          {icon}
        </Grid>
        {contentJSX}
        <Grid className={classes.hrMainText}>
          <DialogContentText className={classes.hrText}>
            <Typography variant="h6">{confirmText}</Typography>
          </DialogContentText>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.hrButton}>
        <Button variant="outlined" onClick={() => confirmAction(false)}>
          Cancel
        </Button>
        <CommonButton
          loading={loading}
          variant="contained"
          onClick={() => {
            confirmAction(true);
          }}
        >
          {btnLable}
        </CommonButton>
      </DialogActions>
    </Dialog>
  );
}
